import createCache from '@emotion/cache'
import type { EmotionCache } from '@emotion/react'

function applyLayerMuiWrap(cache: EmotionCache) {
  const originalInsert = cache.insert
  cache.insert = function (...args) {
    const serialized = args[1]
    if (
      typeof serialized.styles === 'string' &&
      !serialized.styles.startsWith('@layer')
    ) {
      args[1] = {
        ...serialized,
        styles: `@layer mui { ${serialized.styles} }`,
      }
    }
    return originalInsert.apply(this, args)
  }
}

export function createEmotionCache(): EmotionCache {
  const cache = createCache({ key: 'mui', prepend: true })
  applyLayerMuiWrap(cache)
  return cache
}

// Singleton used on the client side
export const clientEmotionCache = createEmotionCache()
